import styled from 'styled-components';


const ScrollNavigator = styled.div`
  margin-top: -${({ theme }) => theme.navbarHeight.mobile};
  margin-bottom: ${({ theme }) => theme.navbarHeight.mobile};
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    margin-top: -${({ theme }) => theme.navbarHeight.desktop};
    margin-bottom: ${({ theme }) => theme.navbarHeight.desktop};
  }
`;

export default ScrollNavigator;
